import { createContext, useCallback, useContext, useEffect, useState, type ReactNode } from "react";
import type { Settings } from "@vereinfach/types";
import { api } from "./api";

type Value = {
  settings: Settings | null;
  refetch: () => Promise<void>;
};

const SettingsContext = createContext<Value | null>(null);

export function SettingsProvider({
  tenantId,
  children,
}: {
  tenantId: string;
  children: ReactNode;
}) {
  const [settings, setSettings] = useState<Settings | null>(null);

  const refetch = useCallback(async () => {
    const data = await api<Settings>(`/tenants/${tenantId}/settings`);
    setSettings(data);
  }, [tenantId]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return (
    <SettingsContext.Provider value={{ settings, refetch }}>{children}</SettingsContext.Provider>
  );
}

export function useSettings(): Value {
  const ctx = useContext(SettingsContext);
  if (!ctx) throw new Error("useSettings must be used inside SettingsProvider");
  return ctx;
}
